import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/homeherosection.css";
import HeroImage from "../assets/images/Hero Image/HeroImage.jpg"
import AOS from "aos";
import "aos/dist/aos.css";

function HomeHeroSection() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out",
    });
  }, []);

  return (
    <section
      className="hero-section d-flex align-items-center text-white position-relative"
      id="home"
    >
      {/* Background Image with Overlay */}
      <div className="hero-bg">
        <img
          src={HeroImage}
          alt="Hero Background"
          className="hero-img"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container position-relative">
        <div className="row">
          <div className="col-lg-8 text-lg-start text-center" data-aos="fade-right" data-aos-delay="100">
            <h1
              className="display-5 fw-bold text-shadow"
              data-aos-delay="200"
            >
              BREATH COMFORT <span style={{ color: "#e85a2a" }}>AIR SYSTEMS</span>
            </h1>
            <p
              className="fs-4 fw-bold text-shadow"
              data-aos-delay="300"
            >
              Changes for a Greener Tomorrow
            </p>
            <p
              className="fs-5 mb-4"
              data-aos-delay="400"
            >
              Providing premium air conditioning solutions with expert service
              for over 18 years.
            </p>

            {/* Buttons */}
            <div
              className="d-flex flex-wrap gap-3 justify-content-lg-start justify-content-center"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <a href="/services" className="btn btn-lg services-btn">
                Explore Our Services
              </a>
              <a
                href={window.innerWidth <= 768 ? "tel:+9194949499" : "https://wa.me/9194949499"}
                className="btn btn-lg fw-medium border-2 bg-white hover-effect consultation-btn text-dark"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get a Free Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <a href="#about">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="arrow">
            <span></span>
          </div>
        </a>
      </div>
    </section>
  );
}

export default HomeHeroSection;